module.exports = __webpack_public_path__ + "static/media/logo.458a3c8f.svg";